module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"coupons":{"sub_title":"可用优惠券列表","expires_at":"有效期至：{0}","unlimited":"有效期：长期有效"},"button":"查看我的优惠券","hint":"*根据优惠券到期时间的不同，可能会显示已过期的优惠券。点击“查看我的优惠券”按钮可进行更准确的确认。"}}')
  delete Component.options._Ctor
}
